import { useState, useCallback } from 'react';
import type { MapRegion } from '../../../types/map';

const regionMapping: Record<string, string> = {
  Noroeste: 'Noroeste e Alto Paranaiba',
  Centro: 'Centro',
  Norte: 'Norte',
  Sul: 'Sul',
  'Centro-oeste': 'Centro-Oeste e Sudoeste',
  'Rio-doce': 'Rio Doce e Vale do Aco',
  'Zona-da-mata': 'Zona da Mata',
  Jequitinhonha: 'Jequitinhonha e Mucuri',
  Triangulo: 'Triangulo',
};

const normalizeText = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const useMapInteraction = (regions: MapRegion[]) => {
  const [selectedRegion, setSelectedRegion] = useState<MapRegion | null>(null);

  const handleRegionClick = useCallback((regionId: string) => {
    if (!Array.isArray(regions)) {
      console.error("Prop 'regions' esta indefinida ou nao e um array!", regions);
      return;
    }

    const backendRegionTitle = regionMapping[regionId];

    if (!backendRegionTitle) {
      console.warn(`Mapeamento nao encontrado para regiao: ${regionId}`);
      return;
    }

    const normalizedBackendTitle = normalizeText(backendRegionTitle);
    const region = regions.find((item) => normalizeText(item['map-region-title']) === normalizedBackendTitle);

    if (!region) {
      console.warn(
        `Regiao nao encontrada: ${backendRegionTitle}`,
        regions.map((item) => item['map-region-title'])
      );
      return;
    }

    setSelectedRegion(region);
  }, [regions]);

  const handleCloseDialog = useCallback(() => {
    setSelectedRegion(null);
  }, []);

  return {
    selectedRegion,
    handleRegionClick,
    handleCloseDialog,
    setSelectedRegion
  };
};
